import { render } from "./FormZipcode.vue?vue&type=template&id=1cad1ffe&scoped=true"
const script = {}

import "./FormZipcode.vue?vue&type=style&index=0&id=1cad1ffe&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cad1ffe"]])

export default __exports__